; (function ($) {

	$.fn.showMask = function () {
		var loader = $("<div></div>")
			.addClass("loader-container")
			.append(
				$("<div></div>").addClass("spr-loading"),
				$("<div>&nbsp;</div>").addClass("loader-overlay"));

		this.addClass("relative").append(loader);

		return this;
	};

	$.fn.hideMask = function () {
		this.removeClass("relative")
			.find(".loader-container")
			.remove();

		return this;
	}

})(jQuery);